module.exports = __webpack_public_path__ + "media/images/up-45a6a445b4d2b3c418ac0608531bc804.png";